query allBaseballPlayers(
  $first: Int
  $offset: Int
  $filter: BaseballPlayerWithTeamFilter
  $condition: BaseballPlayerWithTeamCondition
) {
  players: allBaseballPlayerWithTeams(
    first: $first
    offset: $offset
    filter: $filter
    condition: $condition
  ) {
    nodes {
      teams
      player {
        name
        source
        playerIndex
        position
        playerId
      }
    }
    totalCount
  }
}